class Currencies {
  static XXX = 0;
  static USD = 1;
  static EUR = 2;
  static GBP = 3;
  static CHF = 4;
  static JPY = 5;
  static CAD = 6;
  static AUD = 7;
  static NZD = 8;
  static kr = 9;
  static SEK = 10;
  static NOK = 11;
  static SGD = 12;
  static RUB = 13;
  static TRY = 14;
  static HKD = 15;
  static ZAR = 16;
  static MXN = 17;
  static CZK = 18;
  static HUF = 19;
  static PLN = 20;
  static ISK = 21;
  static AED = 22;
  static CNY = 23;
  static INR = 24;
  static BRL = 25;
  static ILS = 26;
  static SAR = 27;
  static AFA = 28;
  static ALL = 29;
  static AMD = 30;
  static ANG = 31;
  static AOK = 32;
  static AON = 33;
  static AOR = 34;
  static ARS = 35;
  static AWF = 36;
  static AWG = 37;
  static AZN = 38;
  static BAD = 39;
  static BBD = 40;
  static BDT = 41;
  static BGN = 42;
  static BHD = 43;
  static BIF = 44;
  static BMD = 45;
  static BND = 46;
  static BOB = 47;
  static BPS = 48;
  static BSD = 49;
  static BTN = 50;
  static BTR = 51;
  static BWP = 52;
  static BYR = 53;
  static BZD = 54;
  static CDF = 55;
  static CFP = 56;
  static CLP = 57;
  static COP = 58;
  static CRC = 59;
  static CVE = 60;
  static DOP = 61;
  static DZD = 62;
  static ECS = 63;
  static ERN = 64;
  static ETB = 65;
  static FJD = 66;
  static FKP = 67;
  static GEL = 68;
  static GHC = 69;
  static GMD = 70;
  static GNF = 71;
  static GTQ = 72;
  static GWP = 73;
  static GYD = 74;
  static HNL = 75;
  static HRK = 76;
  static HTG = 77;
  static IDR = 78;
  static IQD = 79;
  static IRR = 80;
  static JMD = 81;
  static JOD = 82;
  static KES = 83;
  static KGS = 84;
  static KHR = 85;
  static KMF = 86;
  static KPW = 87;
  static KRW = 88;
  static KTS = 89;
  static KWD = 90;
  static KYD = 91;
  static KYS = 92;
  static KZT = 93;
  static LAK = 94;
  static LBP = 95;
  static LKR = 96;
  static LRD = 97;
  static LSL = 98;
  static LYD = 99;
  static MAD = 100;
  static MDL = 101;
  static MGF = 102;
  static MKD = 103;
  static MMK = 104;
  static MNT = 105;
  static MOP = 106;
  static MRO = 107;
  static MUR = 108;
  static MVR = 109;
  static MWK = 110;
  static MXV = 111;
  static MYR = 112;
  static MZM = 113;
  static NAD = 114;
  static NGN = 115;
  static NIO = 116;
  static NPR = 117;
  static OMR = 118;
  static PEN = 119;
  static PGK = 120;
  static PHP = 121;
  static PKR = 122;
  static PYG = 123;
  static QAR = 124;
  static RON = 125;
  static RSD = 126;
  static RWF = 127;
  static SBD = 128;
  static SCR = 129;
  static SDD = 130;
  static SHP = 131;
  static SIT = 132;
  static SLL = 133;
  static SOS = 134;
  static SRD = 135;
  static STD = 136;
  static SVC = 137;
  static SYP = 138;
  static SZL = 139;
  static THB = 140;
  static TJR = 141;
  static TMM = 142;
  static TND = 143;
  static TOP = 144;
  static TPE = 145;
  static TTD = 146;
  static TWD = 147;
  static TZS = 148;
  static UAH = 149;
  static UGS = 150;
  static UYU = 151;
  static UZS = 152;
  static VEB = 153;
  static VND = 154;
  static VUV = 155;
  static WST = 156;
  static XAF = 157;
  static XCD = 158;
  static XOF = 159;
  static XPF = 160;
  static YER = 161;
  static ZMK = 162;
  static ZRN = 163;
  static ZWD = 164;
  static BAM = 165;
  static EGP = 166;
  static BTC = 167;
  static BCH = 168;
  static BTG = 169;
  static ETH = 170;
  static BSV = 171;
  static LTC = 172;
  static CR1 = 173;
  static CR2 = 174;
  static CR3 = 175;
  static CR4 = 176;
  static CR5 = 177;
  static CR6 = 178;
  static CR7 = 179;
  static CR8 = 180;
  static CR9 = 181;
  static CRA = 182;
  static CRB = 183;
  static CRD = 184;
  static CRE = 185;
  static CRF = 186;
  static CRG = 187;
  static CRH = 188;
  static CRI = 189;
  static CRJ = 190;
  static CRK = 191;
  static CRM = 192;
  static CRN = 193;
  static CRO = 194;
  static CRP = 195;

  static valueToCode = Object.entries(Currencies)
    .filter(([key, value]) => typeof value === 'number')
    .reduce((acc, [key, value]) => {
      acc[value] = key;
      return acc;
    }, {});

  static getCodeByValue(value) {
    let code = Currencies.valueToCode[value];
    if (code === undefined) {
      return 'UNKNOWN';
    }
    return code;
  }
}

export default Currencies;
